import script from "./SearchUserInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchUserInput.vue?vue&type=script&setup=true&lang=js"

import "./SearchUserInput.vue?vue&type=style&index=0&id=077febf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-077febf4"]])

export default __exports__